import axios from 'axios';

// This creates a special version of axios for our app
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://e-commerce-backend-h191.onrender.com'
});

export default api;